import React from "react"; 
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import TopperX from './Pages/TopperX'; 
import TopperXII from './Pages/TopperXII'; 
import VideoGallery from './Pages/VideoGallery'; 
import Tc from './Pages/Tc'; 
import PrincipalMessage from './Pages/PrincipalMessage'; 
import ErpSoftware from './Pages/ErpSoftware'; 
import Events from './Pages/Events';
import News from './Pages/News';
import Gallery from './Pages/Gallery';
import SubGallery from './Pages/SubGallery';
import VisionMission from './Pages/VisionMission';
import OurHistory from './Pages/OurHistory'; 
import AboutUs from './Pages/AboutUs';  
import Home from './Pages/Home';  
import ManagingCommittee from'./Pages/ManagingCommittee'
import StaffMembers from'./Pages/StaffMembers'
import FeeStructure from'./Pages/FeeStructure'
import SchoolUniform from'./Pages/SchoolUniform'
import ContactUs from'./Pages/ContactUs'
import Infrastructure from'./Pages/Infrastructure'
import CBSEDisclosure from'./Pages/CBSEDisclosure'
import RulesRegulations from'./Pages/RulesRegulations'
 import Club from'./Pages/Club'
import AgeCriteria from'./Pages/AgeCriteria'
 import Admission from'./Pages/Admission'
 import EntranceTest from'./Pages/EntranceTest'
 import SquadSystem from'./Pages/SquadSystem'
function App() { 
  return (
    <>
      <BrowserRouter>
        <Routes> 
          <Route path="/" element={<Home />}/> 
          <Route path="/TopperX" element={<TopperX />} />
          <Route path="/TopperXII" element={<TopperXII />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
          <Route path="/Tc" element={<Tc />} />
          <Route path="/PrincipalMessage" element={<PrincipalMessage />} />
          <Route path="/ErpSoftware" element={<ErpSoftware />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/News" element={<News />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/SubGallery" element={<SubGallery />} />
          <Route path="/VisionMission" element={<VisionMission />} />
          <Route path="/OurHistory" element={<OurHistory />} />  
           <Route path="/AboutUs" element={<AboutUs />} />  
           <Route path="/ManagingCommittee" element={<ManagingCommittee />} /> 
            <Route path="/StaffMembers" element={<StaffMembers />} /> 
           <Route path="/FeeStructure" element={<FeeStructure />} /> 
           <Route path="/SchoolUniform" element={<SchoolUniform />} /> 
          <Route path="/ContactUs" element={<ContactUs />} /> 
           <Route path="/Infrastructure" element={<Infrastructure />} />
            <Route path="/CBSEDisclosure" element={<CBSEDisclosure />} />
             <Route path="/RulesRegulations" element={<RulesRegulations />} />
             <Route path="/Club" element={<Club />} />
              <Route path="/Admission" element={<Admission />} />
            <Route path="/AgeCriteria" element={<AgeCriteria />} />
             <Route path="/EntranceTest" element={<EntranceTest />} />
            <Route path="/SquadSystem" element={<SquadSystem />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
